import { CASCADE_GATE_SCENARIO_ID, STARTER_PACK_MDI_ICONS } from '../constants'
import { canDisableStarterPackScenario } from './scenarioActions'

export function doctorMetricIcon(status) {
    if (status === 'bad') {
        return 'mdi-flash'
    }
    if (status === 'warn') {
        return 'mdi-exclamation'
    }
    return 'mdi-check'
}

export function mdiIcon(iconKey) {
    return STARTER_PACK_MDI_ICONS[iconKey] || 'mdi-help-circle-outline'
}

export function showConfigureButton(scenario) {
    return Boolean(scenario.meta.settingsType) || scenario.action === 'redirect'
}

export function isScenarioActive(scenario) {
    return scenario.status === 'active'
}

export function showDisableButton(scenario) {
    return canDisableStarterPackScenario(scenario)
}

export function isCascadeGateUnlocked(scenarios) {
    const gateScenario = (scenarios || []).find(item => item.scenarioId === CASCADE_GATE_SCENARIO_ID)
    return isScenarioActive(gateScenario)
}

export function isScenarioCascadeLocked(scenario, scenarios) {
    if (!scenario || scenario.scenarioId === CASCADE_GATE_SCENARIO_ID) {
        return false
    }
    return !isCascadeGateUnlocked(scenarios)
}

export function getConfigureButtonLabel(scenario) {
    if (scenario?.meta?.settingsType === 'script') {
        return 'Скрипт и условия'
    }
    return isScenarioActive(scenario) ? 'Активен' : 'Настроить'
}

export function getConfigureButtonIcon(scenario) {
    return isScenarioActive(scenario) ? 'mdi-check' : 'mdi-cog'
}

export function getConfigureButtonClasses(scenario) {
    return {
        active: isScenarioActive(scenario),
    }
}

export function caseAreaPoints(bars) {
    if (!bars.length) {
        return ''
    }
    return bars
        .map((height, index) => {
            const x = (index / (bars.length - 1)) * 100
            const y = 55 - (height / 100) * 50
            return `${x.toFixed(1)},${y.toFixed(1)}`
        })
        .join(' ')
}

export function caseAreaPolygon(bars) {
    return `0,58 ${caseAreaPoints(bars)} 100,58`
}
